<template>
  <van-dialog
      v-model:show="visible"
      :before-close="beforeClose"
      :title="dialogTitle"
      show-cancel-button
  >
    <div v-if="showTips" class="phone-tips">{{ tipsText }}</div>

    <van-form>
      <van-cell-group inset>
        <van-field
            v-model="form.phone"
            label="手机号"
            placeholder="请输入手机号"
            type="tel"
            clearable
        />
        <van-field
            v-model="form.code"
            class="code"
            center
            clearable
            type="tel"
            label="验证码"
            placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
                size="small"
                class="get-code"
                type="primary"
                color="#00D477"
                @click.prevent="sendSmsCode"
                :disabled="isSmsSend"
            >
              {{ sendBtnText }}
            </van-button>
          </template>
        </van-field>
      </van-cell-group>
    </van-form>
  </van-dialog>
</template>

<script>
import { Dialog, Field, CellGroup, Form, Button, Toast } from 'vant';
import { bindPhone, getCode } from '@/api/user';

export default {
  name: 'BindPhoneDialog',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Button.name]: Button,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: '绑定手机号',
    },
    showTips: {
      type: Boolean,
      default: true,
    },
    tipsText: {
      type: String,
      default: '根据监管部门要求，用户需要进行手机号码验证，验证后平台将保护您的个人隐私不会泄露，不会使用您的手机号进行发短信和打电话！',
    },
  },
  emits: ['update:show', 'bind-success', 'close'],
  data() {
    return {
      form: {
        phone: '',
        code: '',
      },
      isSmsSend: false,
      sendBtnText: '发送验证码',
      timer: null,
      counter: 60,
      pattern: /1[3-9]\d{9}$/,
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.$emit('close');
        this.reset();
        this.form = { phone: '', code: '' };
      }
    },
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    sendSmsCode() {
      if (!this.form.phone) {
        Toast('请输入手机号');
        return false;
      }
      if (!this.pattern.test(this.form.phone)) {
        Toast('请输入正确的手机号码');
        return false;
      }

      this.isSmsSend = true;
      this.countDown();

      getCode({ phone: this.form.phone }).then((res) => {
        if (res.data.code === '00000') {
          Toast("发送成功，验证码5分钟内有效");
        } else {
          Toast("获取失败");
          this.reset();
        }
      });
    },

    countDown() {
      this.timer = setInterval(() => {
        this.sendBtnText = `${this.counter}秒`;
        this.counter--;
        if (this.counter < 0) {
          this.reset();
        }
      }, 1000);
    },

    reset() {
      this.isSmsSend = false;
      this.sendBtnText = '发送验证码';
      this.clearTimer();
      this.counter = 60;
    },

    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    beforeClose(action) {
      return new Promise(async (resolve) => {
        if (action === 'confirm') {
          if (this.form.code.length !== 6) {
            Toast('请输入验证码');
            resolve(false);
            return;
          }

          await bindPhone(this.form).then(res => {
            if (res.data.code === '00000') {
              this.visible = false;
              this.$emit('bind-success');
              Toast("绑定成功");
              resolve(true);
            } else if (res.data.code === '00007') {
              Toast("验证码错误");
              resolve(false);
            } else if (res.data.code === '00008') {
              Toast("手机号已被其他用户绑定，请更换手机号");
              resolve(false);
            } else {
              Toast("绑定失败");
              resolve(false);
            }
          }).catch(() => {
            Toast("绑定失败");
            resolve(false);
          });
        } else {
          this.$emit('close');
          resolve(true);
        }
      });
    },
  },
};
</script>

<style scoped>
.phone-tips {
  font-size: 13px;
  margin: 15px;
  color: #9ca3af;
}
</style>